@if (visible) {
  <div class="brand-filter">
    <label class="field__label">{{label}}</label>
    <app-brand-select multiple [items]="brands" displayField="name" valueField="companyId"
      placeholder="All brands" searchPlaceholder="Search brands…"
      [ngModel]="companyIds" [ngModelOptions]="{ standalone: true }"
      (selectionChange)="onSelectionChange($event)"></app-brand-select>
  </div>
}
